import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD = 10;
const Container = styled.div.withConfig({
  displayName: "RegistrationEmailSendingAcknowledgement__Container",
  componentId: "vhj2nn-0"
})(({
  $spaceCssStyles
}) => {
  return Object.assign({}, $spaceCssStyles);
});
const RegistrationEmailSendingAcknowledgement = props => {
  const {
    contentCount = 1,
    contentType,
    isEmailSendingAcknowledgementChecked,
    onEmailSendingAcknowledgementChange,
    unregisteredContacts
  } = props;
  const {
    tokenProps
  } = filterProps(props);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  const handleRegistrationEmailAcknowledgementChange = ({
    target: {
      checked
    }
  }) => {
    onEmailSendingAcknowledgementChange(checked);
  };
  return /*#__PURE__*/_jsx(Container, {
    $spaceCssStyles: spaceCssStyles,
    children: /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contentAccessControl.accessGroupsSelect.alerts.emailSendingAcknowledgement.title"
      }),
      type: "warning",
      children: /*#__PURE__*/_jsx(Checkbox, {
        "data-test-id": "registration-email-acknowledgement-checkbox",
        checked: isEmailSendingAcknowledgementChecked,
        onChange: handleRegistrationEmailAcknowledgementChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `contentAccessControl.accessGroupsSelect.alerts.emailSendingAcknowledgement.body.${contentType}`,
          options: {
            count: contentCount,
            contactCount: unregisteredContacts
          }
        })
      })
    })
  });
};
export default RegistrationEmailSendingAcknowledgement;